import React from 'react';

const LayoutContext = React.createContext(null);

export default LayoutContext;
